export const config = {
  title: "Vasconcelos Cleaning Company | Quality Cleaning Services in Midland, TX",
  meta: {
    description:
      "Vasconcelos Cleaning Company offers professional and reliable home cleaning services in Midland, TX, ensuring your space is spotless and comfortable.",
    keywords: [
      'Cleaning Services Midland',
      'Home Cleaning',
      'Residential Cleaning',
      'Vasconcelos Cleaning Company',
      'Maid Services',
      'Deep Cleaning',
      'Housekeeping Midland',
      'Texas Cleaning Services',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: "Vasconcelos Cleaning Company",
    canonicalUrl: 'https://vasconceloscleaning.com/',
  },
  sections: {
    header: {
      businessName: "Vasconcelos Cleaning Company",
    },
    sectionB: {
      heroTitle: "Vasconcelos Cleaning Company",
      heroSubtitle: 'Quality Cleaning for Every Space, Every Time',
      learnAboutText: 'Explore Our Services',
      phoneNumber: '4322560076',
      phoneLabel: '(432) 256-0076',
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1794629243/photo/woman-maid-cleaning-and-wiping-the-table-with-microfiber-cloth-in-office.jpg?s=612x612&w=0&k=20&c=yE1r3oUanfjS6UVqm1H2A8jQVLss288VVEe2d-3tY04=",
      cardData: [
        {
          title: 'Mission',
          description:
            'At Vasconcelos Cleaning Company, our mission is to provide quality and reliable home cleaning services to our local community in Midland, TX.',
        },
        {
          title: 'Vision',
          description:
            'Our vision is to be the preferred choice for residential cleaning services in Midland, known for our professionalism and attention to detail.',
        },
        {
          title: 'Why Choose Us',
          description:
            'We offer personalized cleaning solutions tailored to your needs, ensuring a spotless and comfortable living environment.',
        },
      ],
      description:
        "Vasconcelos Cleaning Company specializes in residential cleaning services, offering deep cleaning, regular housekeeping, and move-in/move-out cleaning to keep your home pristine.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        "Discover the comprehensive cleaning services we offer to maintain the cleanliness and comfort of your home.",
      cards: [
        {
          title: 'Deep Cleaning',
          description:
            'Comprehensive cleaning solutions for spaces that need extra care and attention.',
          imageSrc:
            'https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/2fcf207f-9d26-4bb0-afae-5734455fee896cfb.jpg?alt=media&token=0f55e1a5-3310-47e4-87db-b0dc01d67b8f',
          imageAlt: 'Deep Cleaning Services',
        },
        {
          title: 'Airbnb Cleaning',
          description:
            'Professional cleaning services for short-term rental properties to ensure a fresh and welcoming experience for guests.',
          imageSrc:
            'https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/8cd670aa-04aa-422d-a4c1-bd2ae4bd09edece8.png?alt=media&token=cd990c0b-b82f-4d9b-91fc-d79207a6b60a',
          imageAlt: 'Airbnb Cleaning Services',
        },
        {
          title: 'Commercial Cleaning',
          description:
            'Thorough cleaning services for offices, businesses, and commercial properties to maintain a pristine and professional workspace.',
          imageSrc:
            'https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/72cfc589-9093-4e2d-baf7-dc6d179eca0149cc.jpg?alt=media&token=fd49b408-7631-4d2d-b03f-42b15e667fcc',
          imageAlt: 'Commercial Cleaning Services',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'Move-In/Move-Out Cleaning',
        'Warehouse Cleaning',
        'Residential Cleaning',
        'House Cleaning',
        'Post-Construction Cleaning',
        'Office Cleaning'
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src:
          'https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/d0fbd687-2ed8-475f-a8c3-55270b253683cc15.jpg?alt=media&token=9bb5a42d-d59e-4811-8f4f-03a67d90cde1',
        alt: "Vasconcelos Cleaning Company Team",
      },
      aboutText: [
        "At Vasconcelos Cleaning Company, we are dedicated to providing top-notch cleaning services to our clients in Midland, TX. Our team is committed to ensuring your home is clean, comfortable, and inviting.",
        "With a focus on reliability and quality, we tailor our services to meet your specific needs, ensuring satisfaction with every visit.",
      ],
    },
    sectionE: {
      profileImage: 'https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/c738760a-e526-4171-9005-34fa415bbe2878fd.png?alt=media&token=9517b340-ef35-482f-a9a2-5034c21f860a',
      profileAlt: "Vasconcelos Cleaning Company",
      businessName: "Vasconcelos Cleaning Company",
      contact: {
        phone: '4322560076',
        phoneLabel: '(432) 256-0076',
        email: 'vasconceloscleaningcompany@gmail.com',
        website: 'https://vasconceloscleaning.com/',
        address: 'Midland, TX',
      },
      socialMedia: {
        facebook: 'https://www.facebook.com/profile.php?id=61557243539276',
        instagram: 'https://www.instagram.com/vasconceloscleanservices/',
      },
    },
    sectionF: {
      address: 'Midland, TX',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3309.123456789012!2d-102.1234567!3d31.1234567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86f8c1234567890!2sMidland,+TX!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
